import { render, staticRenderFns } from "./ColumnsList.vue?vue&type=template&id=56846b3a&scoped=true"
import script from "./ColumnsList.vue?vue&type=script&lang=js"
export * from "./ColumnsList.vue?vue&type=script&lang=js"
import style0 from "./ColumnsList.vue?vue&type=style&index=0&id=56846b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56846b3a",
  null
  
)

export default component.exports